import { FileText, MonitorPlay } from "lucide-react"
import type { PromptFile } from "./types"
import type { KnowledgeBaseFile } from "@/app/store/api/knowledgeBaseApi"

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + " " + sizes[i]
}

export const getFileVisuals = (file: PromptFile) => {
    const type = (file as File).type || (file as KnowledgeBaseFile).fileType || ""
    const fileName = (file as File).name || (file as KnowledgeBaseFile).fileName || ""

    if (type === "application/pdf" || fileName.toLowerCase().endsWith('.pdf')) {
        return {
            icon: <FileText className="w-3.5 h-3.5 text-white" />,
            bg: "bg-red-500",
            label: "PDF"
        }
    }
    if (type.includes("word") || type.includes("docx") || fileName.toLowerCase().endsWith('.docx') || fileName.toLowerCase().endsWith('.doc')) {
        return {
            icon: <FileText className="w-3.5 h-3.5 text-white" />,
            bg: "bg-blue-600",
            label: "DOCX"
        }
    }
    if (type.includes("presentation") || type.includes("pptx") || fileName.toLowerCase().endsWith('.pptx') || fileName.toLowerCase().endsWith('.ppt')) {
        return {
            icon: <MonitorPlay className="w-3.5 h-3.5 text-white" />,
            bg: "bg-orange-500",
            label: "PPTX"
        }
    }
    return {
        icon: <FileText className="w-3.5 h-3.5 text-white" />,
        bg: "bg-slate-500",
        label: "FILE"
    }
}
